module.exports = __webpack_public_path__ + "img/full5-min.7a1b352e.png";